// App.jsx
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import TagManager from "./pages/TagManager";
import StatusManager from "./pages/StatusManager";
import Order from "./pages/Order";
import { AuthProvider, useAuth } from "./context/AuthContext";

// ✨ shadcn
import { Button } from "./components/ui/button";
import { Separator } from "./components/ui/separator";
import AppSidebar from "./components/AppSidebar";

function ProtectedRoute({ element }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-4 text-sm text-muted-foreground">Loading…</div>;
  return user ? element : <Navigate to="/" />;
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App flex min-h-screen flex-col bg-background text-foreground pb-[env(safe-area-inset-bottom)]" dir="rtl">
          <Navbar />
          <main className="container mx-auto flex-1 px-4 py-4">
            <Routes>
              <Route path="/" element={<Home />} />
              {/* <Route path="/about" element={<About />} /> */}
              <Route path="/tags" element={<ProtectedRoute element={<TagManager />} />} />
              <Route path="/statuses" element={<ProtectedRoute element={<StatusManager />} />} />
              <Route path="/orders" element={<ProtectedRoute element={<Order />} />} />
              {/* <Route path="/insert_order" element={<ProtectedRoute element={<InsertOrder />} />} /> */}
            </Routes>
          </main>
        </div>
      </AuthProvider>
    </Router>
  );
}

// Navbar: hamburger sidebar (right) + app title + auth action. Kept to a single
// fixed-height row so it stays stable on phones as more screens are added.
function Navbar() {
  const { user, login, logout } = useAuth();

  return (
    <header className="sticky top-0 z-40 w-full border-b bg-background/80 pt-[env(safe-area-inset-top)] backdrop-blur">
      <div className="container mx-auto flex h-14 items-center justify-between gap-2 px-4">
        <div className="flex min-w-0 items-center gap-2">
          <AppSidebar />
          <Link
            to="/"
            className="truncate text-base font-semibold text-primary hover:opacity-80"
          >
            ניהול חנות
          </Link>
        </div>

        {/* Divider shown only on md+ to structure the header (optional) */}
        <Separator className="mx-3 hidden h-6 shrink-0 md:block" orientation="vertical" />

        {/* Right side: auth action */}
        <div className="flex shrink-0 items-center gap-2">
          {user ? (
            <Button variant="destructive" size="sm" onClick={logout}>
              התנתק
            </Button>
          ) : (
            <Button size="sm" onClick={login}>
              חיבור עם גוגל
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}

export default App;
